import { isBeekeeperAdminAllowed } from '@lumapps/beekeeper/ducks/selectors';
import { isBeekeeperFeatureEnabled } from '@lumapps/features/ducks/selectors';
import { createSelector } from '@lumapps/redux/reselect';

export const isWorkflowsManagementEnabled = isBeekeeperFeatureEnabled('workflows_management');

export const isWorkflowsAllowed = createSelector(
    isBeekeeperAdminAllowed,
    isWorkflowsManagementEnabled,
    (isAdminAllowed, isManagementEnabled) => {
        return isAdminAllowed && isManagementEnabled;
    },
);
